<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-users text-white"></i></div>
        <div>
          User Management
          <div class="page-title-subheading">Create users and assign products/steps.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mb-3 card">
        <div class="card-header d-flex justify-content-between align-items-center">
          Users
          <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#addOperatorModal" (click)="openAddModal()">
            <i class="fa fa-plus mr-1"></i> Add User
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
          </div>
          <vio-table-v2 *ngIf="!loading" [tableData]="tableData" [tableConfig]="tableConfig"></vio-table-v2>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Operator modal -->
  <div class="modal fade" id="addOperatorModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ operation === 'Add' ? 'Add User' : 'Edit User — ' + newUser.name }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 form-group">
              <label class="required">Name</label>
              <input class="form-control" placeholder="Name" autocomplete="off" [(ngModel)]="newUser.name" />
            </div>
            <div class="col-md-6 form-group">
              <label class="required">Username</label>
              <input class="form-control" placeholder="Username" autocomplete="off" [(ngModel)]="newUser.username" [disabled]="operation === 'Edit'" />
              <small class="text-muted" *ngIf="operation === 'Edit'">Username can't be changed after creation.</small>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label>Role</label>
              <select class="form-select" [(ngModel)]="newUser.role">
                <option *ngFor="let r of roles" [value]="r.role_name">{{ r.role_name | camelToTitle }}</option>
              </select>
            </div>
            <div class="col-md-6 form-group">
              <label>Language</label>
              <select class="form-select" [(ngModel)]="newUser.language">
                <option value="en">English</option>
                <option value="mr">Marathi</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label [class.required]="operation === 'Add'">Password</label>
            <div class="input-group">
              <input
                class="form-control"
                [type]="showNewUserPassword ? 'text' : 'password'"
                [placeholder]="operation === 'Add' ? 'Password' : 'Leave blank to keep current password'"
                autocomplete="new-password"
                [(ngModel)]="newUser.password"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  [attr.aria-label]="showNewUserPassword ? 'Hide password' : 'Show password'"
                  (click)="showNewUserPassword = !showNewUserPassword"
                >
                  <i class="fa" [class.fa-eye]="!showNewUserPassword" [class.fa-eye-slash]="showNewUserPassword"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #addOperatorCloseBtn>Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveUser()">
            <i class="fa" [class.fa-plus]="operation === 'Add'" [class.fa-save]="operation === 'Edit'" [class.mr-1]="true"></i>
            {{ operation === 'Add' ? 'Add User' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Per-operator modals: Language / Assignments -->
  <ng-container *ngFor="let user of users; trackBy: trackByUserId">
    <!-- Language modal -->
    <div class="modal fade" id="languageModal-{{ user._id }}" tabindex="-1" aria-hidden="true" appAppendToBody>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Language — {{ user.name }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Language</label>
              <select class="form-select" [(ngModel)]="user.language">
                <option value="en">English</option>
                <option value="mr">Marathi</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveLanguage(user)">Save</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Assignments modal -->
    <div class="modal fade" id="assignmentsModal-{{ user._id }}" tabindex="-1" aria-hidden="true" appAppendToBody>
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Product &amp; Step Assignments — {{ user.name }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body assign-body" *ngIf="user.role === 'operator'; else notAnOperator">
            <div class="assign-product" *ngFor="let product of products">
              <div class="assign-product-header" (click)="toggleProductExpanded(product._id)">
                <i class="fa fa-chevron-right assign-product-caret" [class.expanded]="isProductExpanded(product._id)"></i>
                <span class="assign-product-name">{{ product.name }}</span>
                <span class="assign-product-count">{{ assignedCount(user, product) }}/{{ product.steps.length }}</span>
                <div class="assign-product-bulk" (click)="$event.stopPropagation()">
                  <button type="button" class="assign-bulk-btn" (click)="selectAllSteps(user, product)">All</button>
                  <span class="assign-bulk-sep">/</span>
                  <button type="button" class="assign-bulk-btn" (click)="selectNoSteps(user, product)">None</button>
                </div>
              </div>
              <div class="assign-steps-grid" *ngIf="isProductExpanded(product._id)">
                <label class="assign-step-chip" [class.selected]="isAssigned(user, product._id, step._id)" *ngFor="let step of product.steps">
                  <input
                    class="assign-step-input"
                    type="checkbox"
                    [checked]="isAssigned(user, product._id, step._id)"
                    (change)="toggleStepAssignment(user, product._id, step._id)"
                  />
                  <span class="assign-step-label">{{ step.name }}</span>
                  <i class="fa fa-check assign-step-check"></i>
                </label>
              </div>
            </div>
          </div>
          <ng-template #notAnOperator>
            <div class="modal-body text-center text-muted py-5">
              {{ user.name }} is {{ user.role | camelToTitle | lowercase }}, not an operator — assignments don't apply.
            </div>
          </ng-template>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" *ngIf="user.role === 'operator'" (click)="saveAssignments(user)">Save Assignments</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
